import { useEffect, useState } from "react";

/**
 * A search box that searches as you type (2026-10-22: the Qidirish buttons
 * are gone).
 *
 * `input` is what the box shows; `search` is what the list is filtered by. It
 * follows `input` once typing pauses for `delay` ms, so a word typed quickly
 * is one request, not one per keystroke -- `q` is an ILIKE with no trigram
 * index behind it, so each request is a scan. Enter still applies at once:
 * the forms call `setSearch(input.trim())` on submit.
 */
export function useSearchInput(delay = 350) {
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setSearch(input.trim()), delay);
    return () => clearTimeout(t);
  }, [input, delay]);

  return { input, setInput, search, setSearch };
}
